
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__telegram-filled",
  "use": "icon__telegram-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__telegram-filled\"><path d=\"M12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5zm4.436 7.424c.264-1.589-.267-1.726-1.997-1.009-.547.227-3.926 1.628-7.17 3.026l-.57.247c-.474.205-.94.408-1.39.606-.921.405-1.146.827-.198 1.152.246.085.879.307 1.526.493.857.246 1.335.091 1.832-.246a823.21 823.21 0 0 1 3.134-2.085l.421-.28 1.224-.812c.21-.139.437.146.256.32a866.62 866.62 0 0 0-3.43 3.28c-.762.745-.155 1.123.285 1.437.483.345 2.704 1.814 3.144 2.105.915.604 1.497.438 1.757-.957.13-.698.269-1.52.406-2.363l.102-.633c.286-1.797.548-3.562.668-4.28z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconTelegramFilledIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__telegram-filled" {...restProps} />
    })
  